// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 847) return "static/chunks/a18f0e56-272654971375ac56.js";
	if (chunkId === 974) return "static/chunks/974-2502e5ccd7a14a59.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"a11ee159b6668b20","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"ad30df426b4e66d0","367":"f0feeab0ed6029ea","639":"3b11b1fd85d5c89f","748":"d3c82a22d806c6b8"}[chunkId] + ".js";
};